import { render } from "./ActionPanel.vue?vue&type=template&id=399477a7"
import script from "./ActionPanel.vue?vue&type=script&lang=js"
export * from "./ActionPanel.vue?vue&type=script&lang=js"
script.render = render

export default script